import axios from "axios";
import { Payout_Service } from "../Url";

export const getAddPricingDetailAction = {
  ADD_PARTNER_PRICING_DETAILS_SUCCESS: "ADD_PARTNER_PRICING_DETAILS_SUCCESS",
  ADD_PARTNER_PRICING_DETAILS_ERROR: "ADD_PARTNER_PRICING_DETAILS_ERROR",
  GET_PRICING_DETAIL_SUCCESS: "GET_PRICING_DETAIL_SUCCESS",
  GET_PRICING_DETAIL_ERROR: "GET_PRICING_DETAIL_ERROR",
};

export function addPartnerPricingDetails(props) {
  const { values, partnerFirmId, accessToken } = props;
  return (dispatch) =>
    axios({
      method: "post",
      // url: `http://localhost:8301/partner-payout-service/pricing/save-bunch-pricing/${partnerFirmId}`,
      url: `${Payout_Service}/pricing/save-bunch-pricing/${partnerFirmId}`,
      data: [values],
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(addPricingDetailSuccess(response.data.data));

          return response.data.data;
        }
      })
      .catch((err) => {
        console.log("error:", err);
        return err;
      });
}

export function upadtePartnerPricingDetails(props) {
  const { values, partnerFirmId, accessToken } = props;
  return (dispatch) =>
    axios({
      method: "post",
      //  url: `http://localhost:8301/partner-payout-service/pricing/edit-bunch-pricing/${partnerFirmId}`,
      url: `${Payout_Service}/pricing/edit-bunch-pricing/${partnerFirmId}`,
      data: [values],
      headers: {
        "Access-Control-Allow-Origin": "*",
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        console.log("response", response);

        if (response.status >= 200 && response.status < 300) {
          return response.data.data;
        }else{
          throw new Error(response.statusText);
        }
      })
      .catch((err) => {
        console.log("error:", err);
        return err;
      });
}

export function getAllPricingDetailByPartner(props) {
  const { partnerFirmId, accessToken } = props;
  console.log("line 47", partnerFirmId);

  return (dispatch) => {
    axios({
      method: "post",
      // url: `http://localhost:8301/partner-payout-service/pricing/pricing-by-partner/${partnerFirmId}`,
      url: `${Payout_Service}/pricing/pricing-by-partner/${partnerFirmId}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch({
            type: getAddPricingDetailAction.GET_PRICING_DETAIL_SUCCESS,
            payload: response.data.data,
          });
          console.log("line54", response);

          return response.data.data;
        }
      })
      .catch((err) => {
        console.log("error:", err);
      });
  };
}

export function addPricingDetailSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getAddPricingDetailAction.ADD_PARTNER_PRICING_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
